import { lazy } from "react";

const Logins = lazy(() => import("../Auth/Signin"));
const ForgotPassword = lazy(() => import("../Auth/ForgotPassword"));
const ResetPassword = lazy(() => import("../Auth/ResetPassword"));
const ActivateLicense = lazy(() => import("../Auth/ActivateLicense"));

export const authRoutes = [
  { path: `${process.env.PUBLIC_URL}/login`, Component: <Logins /> },
  { path: `${process.env.PUBLIC_URL}/forgot-password`, Component: <ForgotPassword /> },
  { path: `${process.env.PUBLIC_URL}/reset-password/:_id`, Component: <ResetPassword /> },
  { path: `${process.env.PUBLIC_URL}/activate`, Component: <ActivateLicense /> },
];
